import React, { useState } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { enqueueSnackbar } from 'notistack';
import { yupResolver } from '@hookform/resolvers/yup';
import { postRequest } from 'src/services';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { handleErrorMessages } from 'src/components/risk-management/risk-register/feching';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import Iconify from '../iconify';

const TradeModal = ({ open, onClose, reload, label, url }) => {
  const [loading, setLoading] = useState(false);

  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    trade_code: Yup.string().required('Trade Code is required'),
  });

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues: {
      name: '',
      trade_code: '',
    },
  });

  const { reset, handleSubmit } = methods;

  const handleClose = () => {
    onClose();
    reset();
  };

  const onSubmit = handleSubmit(async (formData) => {
    setLoading(true);

    try {
      const responseData = await postRequest(
        url,
        {
          name: formData.name,
          trade_code: formData.trade_code,
          project_id: localStorage.getItem('projectId'),
        },
        false
      );

      if (responseData.metadata && responseData.metadata.success) {
        onClose();
        reload();
        reset();
        enqueueSnackbar({
          variant: 'success',
          message: 'Created successfully',
        });
      } else {
        handleErrorMessages(responseData.metadata.message);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setLoading(false);
    }
  });

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxSizing: 'content-box',
          }}
        >
          <span
            className="cardColor"
            style={{ padding: '7px', marginLeft: '-25px', color: 'white', fontWeight: '700' }}
          >
            &nbsp;&nbsp; Create Trade &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <IconButton onClick={handleClose}>
            <Iconify icon="mdi:close" />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            mt={2}
            mb={2}
            gap={3}
            display="grid"
            gridTemplateColumns={{
              xs: 'repeat(2, 1fr)',
              lg: 'repeat(2, 1fr)',
            }}
          >
            <RHFTextField name="trade_code" label="Trade Code" type="number" required />
            <RHFTextField name="name" label="Trade Name" required />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="inherit" onClick={handleClose}>
            Cancel
          </Button>
          <LoadingButton
            className="dark-button"
            disabled={loading}
            loading={loading}
            onClick={onSubmit}
            variant="contained"
          >
            Save
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};

export default TradeModal;
